import { RootState } from "../store";

export const selectVesselView = (state: RootState) => state.vesselView;

export const selectSelectedVessel = (state: RootState) => state.vesselView.selectedVessel;

export const selectVesselViewOpen = (state: RootState) => state.vesselView.vesselViewOpen;